import StarBar from "./StarBar";

export default StarBar;
